<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-office-building</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">部署情報編集</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="department_form" v-model="valid" @submit.prevent>
              <v-text-field label="部署名" v-model="name" :rules="departmentNameRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="課名" v-model="section" :rules="sectionNameRules" dense outlined></v-text-field>
              <v-text-field label="工番：固定部" v-model="constructionNumberFixed" :rules="constructionNumberFixedRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="工番：連番部" v-model="constructionNumberSerial" :rules="constructionNumberSerialRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-slider label="工番：連番部桁数" v-model="constructionNumberDigit" :rules="constructionNumberDigitRules" min="1" max="6" thumb-label>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-slider>
              <v-text-field label="工番フォーマット" v-model="constructionNumber" dense outlined disabled></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'DepartmentMaster' }" depressed>キャンセル</v-btn>
            <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleUpdate
        @updated="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import DepartmentApi from "@/api/department-api";
import CustomDialog from "@/components/custom_ui/CustomDialog";
import Rule from "@/validation/rules";
import statusList from "@/helpers/const";

export default {
  name: "EditDepartmentMaster",
  components: {
    CustomDialog
  },
  data: () => ({
    loading: false,
    //フォームの項目
    name: "",
    section: "",
    constructionNumberFixed: "#####-",
    constructionNumberSerial: 1,
    constructionNumberDigit: 6,
    constructionNumber: "",

    // 更新ダイアログ
    dialogMaxWith: 500,
    dialogTitle: "",
    dialogItems: [],
    dialogDrawer: false,
    editId: null,

    // バリデーション
    valid: true,
    departmentNameRules: Rule.departmentNameRules,
    sectionNameRules: Rule.sectionNameRules,
    constructionNumberFixedRules: Rule.constructionNumberFixedRules,
    constructionNumberSerialRules: Rule.constructionNumberSerialRules,
    constructionNumberDigitRules: Rule.constructionNumberDigitRules
  }),
  created() {
    this.initialize();
  },
  watch: {
    constructionNumberFixed () {
      this.constructionNumberFormat();
    },
    constructionNumberSerial (value) {
      this.constructionNumberSerial = this.stringFormat(value);
      this.constructionNumberFormat();
    },
    constructionNumberDigit (value) {
      this.constructionNumberDigit = this.stringFormat(value);
      this.constructionNumberFormat();
    }
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize() {
      this.isLoading();
      this.departmentApi = new DepartmentApi();
      // 機材IDをルートパラメータから取得
      this.editId = this.$route.params.id;
      const promise = this.departmentApi.info(this.editId);
      promise.then(response => {
        this.name = response.data.body.department_info.name;
        if (response.data.body.department_info.section != null) {
          this.section = response.data.body.department_info.section;
        }
        this.constructionNumberFixed = response.data.body.department_info.construction_number_fixed;
        this.constructionNumberSerial = response.data.body.department_info.construction_number_serial;
        this.constructionNumberDigit = response.data.body.department_info.digits;
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          this.$emit("error",error.response.data.message);
          if (error.response.data.status == statusList.status.authError) {
            this.dialogDrawer = false;
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$router.push({ name: "DepartmentMaster" })
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.constructionNumberFormat();
        this.isLoading();
      });
    },
    stringFormat(value) {
      var result = value.toString();
      while (result.match(/[０-９]/g)) {
        result = result.replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
        });
      }
      return result;
    },
    constructionNumberFormat () {
      this.constructionNumber =
      this.constructionNumberFixed + this.constructionNumberSerial.toString().padStart(this.constructionNumberDigit, '0');
    },
    //更新ボタン押下時
    checkDialog() {
      this.dialogTitle = "更新しますか？";
      this.dialogItems = [
        { name: "部署名", value: this.name },
        { name: "課名", value: this.section },
        { name: "工番フォーマット", value: this.constructionNumber }
      ];
      this.dialogDrawer = true;
    },
    dialogCancel() {
      this.dialogDrawer = false;
    },
    //ダイアログ更新ボタン押下時
    submit() {
      if (this.$refs.department_form.validate()) {
        this.isLoading();
        const params = {
          name: this.name,
          section: this.section,
          construction_number_fixed: this.constructionNumberFixed,
          construction_number_serial: this.constructionNumberSerial,
          digits: this.constructionNumberDigit
        };
        const promise = this.departmentApi.update(this.editId, params);
        promise.then(response => {
          this.$router.push({ name: 'DepartmentMaster' });
          this.$emit("success", response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    }
  }
};
</script>
